import { defineMessages } from 'react-intl';

export const analyticsModelMessages = defineMessages({
  title: {
    id: 'analyticsModel.title',
    defaultMessage: 'Tags',
  },
  titleDescription: {
    id: 'analyticsModel.titleDescription',
    defaultMessage:
      'Define reusable tag structures, section prompts and tag groups for generated encounter summaries.',
  },
  createModel: {
    id: 'analyticsModel.createModel',
    defaultMessage: 'Create Model',
  },
  createModelDescription: {
    id: 'analyticsModel.createModelDescription',
    defaultMessage:
      'Create a new tags model with Diagnocat-aligned structure, labels and instructions.',
  },
  editModel: {
    id: 'analyticsModel.editModel',
    defaultMessage: 'Edit Model',
  },
  openModel: {
    id: 'analyticsModel.openModel',
    defaultMessage: 'Open Model',
  },
  name: { id: 'analyticsModel.name', defaultMessage: 'Name' },
  code: { id: 'analyticsModel.code', defaultMessage: 'Code' },
  language: { id: 'analyticsModel.language', defaultMessage: 'Language' },
  instructions: {
    id: 'analyticsModel.instructions',
    defaultMessage: 'Instructions',
  },
  groups: { id: 'analyticsModel.groups', defaultMessage: 'Tag Groups' },
  addGroup: { id: 'analyticsModel.addGroup', defaultMessage: 'Add Group' },
  groupName: { id: 'analyticsModel.groupName', defaultMessage: 'Group Name' },
  groupCode: { id: 'analyticsModel.groupCode', defaultMessage: 'Group Code' },
  groupInstructions: {
    id: 'analyticsModel.groupInstructions',
    defaultMessage: 'Group Instructions',
  },
  selectionMode: {
    id: 'analyticsModel.selectionMode',
    defaultMessage: 'Selection Mode',
  },
  selectionSingle: {
    id: 'analyticsModel.selectionSingle',
    defaultMessage: 'Single',
  },
  selectionMultiple: {
    id: 'analyticsModel.selectionMultiple',
    defaultMessage: 'Multiple',
  },
  required: { id: 'analyticsModel.required', defaultMessage: 'Required' },
  optional: { id: 'analyticsModel.optional', defaultMessage: 'Optional' },
  tags: { id: 'analyticsModel.tags', defaultMessage: 'Tags' },
  addTag: { id: 'analyticsModel.addTag', defaultMessage: 'Add Tag' },
  tagName: { id: 'analyticsModel.tagName', defaultMessage: 'Tag Name' },
  tagCode: { id: 'analyticsModel.tagCode', defaultMessage: 'Tag Code' },
  tagInstructions: {
    id: 'analyticsModel.tagInstructions',
    defaultMessage: 'Tag Instructions',
  },
  tagExplain: {
    id: 'analyticsModel.tagExplain',
    defaultMessage: 'Explain',
  },
  tagExplainDescription: {
    id: 'analyticsModel.tagExplainDescription',
    defaultMessage:
      'Ask AI to return a short explanation for this selected tag',
  },
  hiddenDetails: {
    id: 'analyticsModel.hiddenDetails',
    defaultMessage: 'Contains instructions or advanced details',
  },
  save: { id: 'analyticsModel.save', defaultMessage: 'Save' },
  saving: { id: 'analyticsModel.saving', defaultMessage: 'Saving...' },
  cancel: { id: 'analyticsModel.cancel', defaultMessage: 'Cancel' },
  edit: { id: 'analyticsModel.edit', defaultMessage: 'Edit' },
  delete: { id: 'analyticsModel.delete', defaultMessage: 'Delete' },
  deleteConfirm: {
    id: 'analyticsModel.deleteConfirm',
    defaultMessage: 'Are you sure you want to delete this tags model?',
  },
  saveSuccess: {
    id: 'analyticsModel.saveSuccess',
    defaultMessage: 'Tags model saved',
  },
  deleteSuccess: {
    id: 'analyticsModel.deleteSuccess',
    defaultMessage: 'Tags model deleted',
  },
  noModels: {
    id: 'analyticsModel.noModels',
    defaultMessage: 'No tags models yet',
  },
  removeGroup: {
    id: 'analyticsModel.removeGroup',
    defaultMessage: 'Remove Group',
  },
  removeTag: { id: 'analyticsModel.removeTag', defaultMessage: 'Remove Tag' },
  status: { id: 'analyticsModel.status', defaultMessage: 'Status' },
  tagsCount: {
    id: 'analyticsModel.tagsCount',
    defaultMessage: '{count} tags',
  },
  groupsCount: {
    id: 'analyticsModel.groupsCount',
    defaultMessage: '{count} groups',
  },
  // Sections
  sections: { id: 'analyticsModel.sections', defaultMessage: 'Sections' },
  addSection: {
    id: 'analyticsModel.addSection',
    defaultMessage: 'Add Section',
  },
  sectionName: {
    id: 'analyticsModel.sectionName',
    defaultMessage: 'Section Name',
  },
  sectionCode: {
    id: 'analyticsModel.sectionCode',
    defaultMessage: 'Section Code',
  },
  sectionKind: {
    id: 'analyticsModel.sectionKind',
    defaultMessage: 'Section Type',
  },
  sectionInstructions: {
    id: 'analyticsModel.sectionInstructions',
    defaultMessage: 'Section instructions...',
  },
  sectionKindText: {
    id: 'analyticsModel.sectionKindText',
    defaultMessage: 'Text',
  },
  sectionKindList: {
    id: 'analyticsModel.sectionKindList',
    defaultMessage: 'List',
  },
  sectionsCount: {
    id: 'analyticsModel.sectionsCount',
    defaultMessage: '{count} sections',
  },
  // Group type
  groupTypeAi: {
    id: 'analyticsModel.groupTypeAi',
    defaultMessage: 'AI',
  },
  groupTypeInput: {
    id: 'analyticsModel.groupTypeInput',
    defaultMessage: 'Input',
  },
  // Settings
  modelSettings: {
    id: 'analyticsModel.modelSettings',
    defaultMessage: 'Advanced settings',
  },
  settingsDescription: {
    id: 'analyticsModel.settingsDescription',
    defaultMessage: 'Change the generated code for custom IDs.',
  },
  advanced: {
    id: 'analyticsModel.advanced',
    defaultMessage: 'Advanced',
  },
  // Editor info
  analyticsModel: {
    id: 'analyticsModel.analyticsModel',
    defaultMessage: 'Tags model',
  },
  analyticsModelCode: {
    id: 'analyticsModel.analyticsModelCode',
    defaultMessage: 'Tags model code',
  },
  backToModels: {
    id: 'analyticsModel.backToModels',
    defaultMessage: 'Back to tags models',
  },
  modelOverview: {
    id: 'analyticsModel.modelOverview',
    defaultMessage: 'Model overview',
  },
  workspaceDescription: {
    id: 'analyticsModel.workspaceDescription',
    defaultMessage:
      'Edit model details, instructions, groups and sections one block at a time.',
  },
  viewModeDescription: {
    id: 'analyticsModel.viewModeDescription',
    defaultMessage:
      'Review structure, metadata and instructions before making changes.',
  },
  editModeDescription: {
    id: 'analyticsModel.editModeDescription',
    defaultMessage:
      'Adjust metadata, instructions and generated output structure.',
  },
  modelDetails: {
    id: 'analyticsModel.modelDetails',
    defaultMessage: 'Model details',
  },
  structure: {
    id: 'analyticsModel.structure',
    defaultMessage: 'Structure',
  },
  composeModel: {
    id: 'analyticsModel.composeModel',
    defaultMessage: 'Compose model',
  },
  composeModelDescription: {
    id: 'analyticsModel.composeModelDescription',
    defaultMessage:
      'Add reusable tag sections and tag groups. Finish active edits before creating another block.',
  },
  noInstructionsYet: {
    id: 'analyticsModel.noInstructionsYet',
    defaultMessage: 'No instructions added yet.',
  },
  noGroupsYet: {
    id: 'analyticsModel.noGroupsYet',
    defaultMessage:
      'Add the first tag group to structure extracted clinical or business signals.',
  },
  noSectionsYet: {
    id: 'analyticsModel.noSectionsYet',
    defaultMessage:
      'Add the first tags section to define generated report output.',
  },
  activeEditorNotice: {
    id: 'analyticsModel.activeEditorNotice',
    defaultMessage:
      'Finish or cancel the current edit before adding another block.',
  },
  unsavedChanges: {
    id: 'analyticsModel.unsavedChanges',
    defaultMessage: 'Unsaved changes',
  },
  unsavedChangesDescription: {
    id: 'analyticsModel.unsavedChangesDescription',
    defaultMessage:
      'Save the model to persist the current draft, or discard to roll back to the last saved state.',
  },
  discard: {
    id: 'analyticsModel.discard',
    defaultMessage: 'Discard',
  },
  modelSummary: {
    id: 'analyticsModel.modelSummary',
    defaultMessage: '{groups} groups \u00B7 {sections} sections',
  },
  addElement: {
    id: 'analyticsModel.addElement',
    defaultMessage: 'Add element',
  },
  newGroup: {
    id: 'analyticsModel.newGroup',
    defaultMessage: 'New group',
  },
  newSection: {
    id: 'analyticsModel.newSection',
    defaultMessage: 'New section',
  },
  // Reordering
  moveUp: { id: 'analyticsModel.moveUp', defaultMessage: 'Move up' },
  moveDown: { id: 'analyticsModel.moveDown', defaultMessage: 'Move down' },
  // Instructions placeholder
  modelInstructionsPlaceholder: {
    id: 'analyticsModel.modelInstructionsPlaceholder',
    defaultMessage: 'Model instructions...',
  },
  groupInstructionsPlaceholder: {
    id: 'analyticsModel.groupInstructionsPlaceholder',
    defaultMessage: 'Group instructions...',
  },
  tagInstructionsPlaceholder: {
    id: 'analyticsModel.tagInstructionsPlaceholder',
    defaultMessage: 'Tag instructions...',
  },
  // Settings dialog
  namePlaceholder: {
    id: 'analyticsModel.namePlaceholder',
    defaultMessage: 'Model name',
  },
  codePlaceholder: {
    id: 'analyticsModel.codePlaceholder',
    defaultMessage: 'model_code',
  },
  settings: {
    id: 'analyticsModel.settings',
    defaultMessage: 'Advanced',
  },
  // List & sidebar controls
  searchPlaceholder: {
    id: 'analyticsModel.searchPlaceholder',
    defaultMessage: 'Search models',
  },
  showDeleted: {
    id: 'analyticsModel.showDeleted',
    defaultMessage: 'Show deleted',
  },
  filterByStatus: {
    id: 'analyticsModel.filterByStatus',
    defaultMessage: 'Status',
  },
  filterAll: {
    id: 'analyticsModel.filterAll',
    defaultMessage: 'All',
  },
  filterCurrent: {
    id: 'analyticsModel.filterCurrent',
    defaultMessage: 'Current',
  },
  filterDraft: {
    id: 'analyticsModel.filterDraft',
    defaultMessage: 'Draft',
  },
  emptySearchResults: {
    id: 'analyticsModel.emptySearchResults',
    defaultMessage: 'No models match your search.',
  },
  itemsCount: {
    id: 'analyticsModel.itemsCount',
    defaultMessage: 'Showing {visible} of {total}',
  },
  // Linked encounter types
  linkedEncounterTypes: {
    id: 'analyticsModel.linkedEncounterTypes',
    defaultMessage: 'Linked encounter types',
  },
  linkedSpecialties: {
    id: 'analyticsModel.linkedSpecialties',
    defaultMessage: 'Linked specialties',
  },
  noLinkedSpecialties: {
    id: 'analyticsModel.noLinkedSpecialties',
    defaultMessage: 'No linked specialties',
  },
  notUsedYet: {
    id: 'analyticsModel.notUsedYet',
    defaultMessage: 'Not used by any encounter type yet.',
  },
  usedByCount: {
    id: 'analyticsModel.usedByCount',
    defaultMessage:
      '{count, plural, one {Used by # encounter type} other {Used by # encounter types}}',
  },
  // Actions
  cloneModel: {
    id: 'analyticsModel.cloneModel',
    defaultMessage: 'Clone',
  },
  exportModel: {
    id: 'analyticsModel.exportModel',
    defaultMessage: 'Export',
  },
  restoreModel: {
    id: 'analyticsModel.restoreModel',
    defaultMessage: 'Restore',
  },
  cloneSuccess: {
    id: 'analyticsModel.cloneSuccess',
    defaultMessage: 'Tags model cloned',
  },
  restoreSuccess: {
    id: 'analyticsModel.restoreSuccess',
    defaultMessage: 'Tags model restored',
  },
  cloneConfirm: {
    id: 'analyticsModel.cloneConfirm',
    defaultMessage:
      'Create a copy of this tags model in the current organization?',
  },
  // Detail / list columns
  modelCode: {
    id: 'analyticsModel.modelCode',
    defaultMessage: 'Code',
  },
  modelLanguage: {
    id: 'analyticsModel.modelLanguage',
    defaultMessage: 'Language',
  },
  modelStatus: {
    id: 'analyticsModel.modelStatus',
    defaultMessage: 'Status',
  },
  modelGroups: {
    id: 'analyticsModel.modelGroups',
    defaultMessage: 'Groups',
  },
  modelSections: {
    id: 'analyticsModel.modelSections',
    defaultMessage: 'Sections',
  },
  modelCreated: {
    id: 'analyticsModel.modelCreated',
    defaultMessage: 'Created',
  },
  openEditor: {
    id: 'analyticsModel.openEditor',
    defaultMessage: 'Open editor',
  },
  errorSave: {
    id: 'analyticsModel.errorSave',
    defaultMessage: 'Failed to save',
  },
  errorClone: {
    id: 'analyticsModel.errorClone',
    defaultMessage: 'Failed to clone model',
  },
  errorDelete: {
    id: 'analyticsModel.errorDelete',
    defaultMessage: 'Failed to delete',
  },
  errorRestore: {
    id: 'analyticsModel.errorRestore',
    defaultMessage: 'Failed to restore model',
  },
});
